import { render } from "./LanguageButton.vue?vue&type=template&id=c1870796&scoped=true"
import script from "./LanguageButton.vue?vue&type=script&lang=js"
export * from "./LanguageButton.vue?vue&type=script&lang=js"

import "./LanguageButton.vue?vue&type=style&index=0&id=c1870796&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1870796"]])

export default __exports__